import { render } from "./delivery_trips.vue?vue&type=template&id=678ff60a&scoped=true"
import script from "./delivery_trips.vue?vue&type=script&lang=js"
export * from "./delivery_trips.vue?vue&type=script&lang=js"

import "./delivery_trips.vue?vue&type=style&index=0&id=678ff60a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678ff60a"]])

export default __exports__